module.exports = __webpack_public_path__ + "static/media/ksa-flag1.b9e09bf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/ksa-flag1.svg
// module id = 1103
// module chunks = 2